import { render, staticRenderFns } from "./widgetItem.vue?vue&type=template&id=6040444e"
import script from "./widgetItem.vue?vue&type=script&lang=js"
export * from "./widgetItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports